import React from 'react';

import { MarketingFAQ } from 'client/components/MarketingPagesShared/MarketingFAQ';
import { useT } from 'client/i18n/hooks/useT';

export function FAQ() {
  const t = useT();

  // TODO https://anchorfm.atlassian.net/browse/CAST-2750: Update FAQ List when final copy is ready
  const FAQList = [
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.SharingQuestion',
        'Can I share the same content I share on other platforms?',
        'Integration Connection Screen, FAQ section sharing question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.SharingAnswer',
        'Yes! Upload the same file to Anchor and unlock new audiences on Spotify in just a few clicks.',
        'Integration Connection Screen, FAQ section sharing answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.FormatQuestion',
        'What formats are accepted?',
        'Integration Connection Screen, FAQ section format question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.FormatAnswer',
        'We are currently accepting .mov and .mp4 files and recommend 16x9 aspect ratio.',
        'Integration Connection Screen, FAQ section format answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.AvailabilityQuestion',
        'Where will my videos be available?',
        'Integration Connection Screen, FAQ section availability question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.AvailabilityAnswer',
        'Your videos can be found everywhere podcasts are available on Spotify.',
        'Integration Connection Screen, FAQ section availability answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.LiveStreamQuestion',
        'Can I stream live?',
        'Integration Connection Screen, FAQ section live stream question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.LiveStreamAnswer',
        'This is not a live offering. Check out Spotify Greenroom for live audio streaming options.',
        'Integration Connection Screen, FAQ section live stream answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.WhyVideoQuestion',
        'Why is Spotify adding video?',
        'Integration Connection Screen, FAQ section "why video" question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.WhyVideoAnswer',
        'Spotify has always been a premier destination for content. Whether listening to a newly released album or finding a new podcast, the world comes to Spotify to discover. By adding video, we are ensuring that regardless of what someone is looking for, they can find it on Spotify.',
        'Integration Connection Screen, FAQ section "why video" answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.AddVideoQuestion',
        'Can I add video to my existing audio episodes in Anchor?',
        'Integration Connection Screen, FAQ section adding video to existing podcast question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.AddVideoAnswer',
        'Yes you can!',
        'Integration Connection Screen, FAQ section adding video to existing podcast answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.MonetizeQuestion',
        'Can we monetize?',
        'Integration Connection Screen, FAQ section monetize question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.MonetizeAnswer',
        'Yes — in addition to your own advertising partnerships, we offer several monetization options including Paid Podcast Subscriptions and Ads by Anchor — both coming soon. We are constantly adding new monetization opportunities for Anchor creators.',
        'Integration Connection Screen, FAQ section monetize answer'
      ),
    },
    {
      question: t(
        'IntegrationConnectionScreen.FAQ.AccessQuestion',
        'Who can currently create video podcasts?',
        'Integration Connection Screen, FAQ section access question'
      ),
      answer: t(
        'IntegrationConnectionScreen.FAQ.AccessAnswer',
        "Video Podcasts are currently available in the United States, United Kingdom, Australia, Canada, and New Zealand. If you aren't in one of these countries, you can still submit our interest form and we will let you know when we launch video podcasts in your country.",
        'Integration Connection Screen, FAQ section access answer'
      ),
    },
  ];

  return <MarketingFAQ FAQList={FAQList} />;
}
